
<template>
    <div class='flex h-full ds-npot-par-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
            >
            </ai-tree-list-edit>
        </div>
        <div class='h-full flex flex-col w-full'>
            <div class="tep-header_block">
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Наименование</div>
                    <div style="width: 600px">
                        <ai-text-box-readonly
                            :value='nameTree'
                        ></ai-text-box-readonly>
                    </div>
                </div>
                <div  class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Период</div>
                        <div class="tep-header-input">
                            <tep-lookup
                                :value='kpcTree'
                                :meta='selectMeta.kod_period_create'
                                :data-source='lookupNpotPeriodCreateList'
                                :disabled="true"
                            ></tep-lookup>
                        </div>
                    </div>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Температура</div>
                        <div style="width: 138px">
                            <ai-number-box
                                :value='ttTree'
                                :read-only='true'
                            ></ai-number-box>
                        </div>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Тип прокладки</div>
                        <div class="tep-header-input">
                            <tep-lookup
                                :value='kprTree'
                                :meta='selectMeta.kod_pr'
                                :data-source='lookupNpotTipPrList'
                                :disabled="true"
                            ></tep-lookup>
                        </div>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Время работы</div>
                        <div class="tep-header-input">
                            <tep-lookup
                                :value='ktwTree'
                                :meta='selectMeta.kod_time_work'
                                :data-source='lookupNpotTimeWorkList'
                                :disabled="true"
                            ></tep-lookup>
                        </div>
                    </div>
                </div>
            </div>
            <div  v-if="!isChildTree" class="tep-grid__container">
                <div class='text-xl tep-grid-name'>Нормы потерь</div>
                <ai-grid-ro
                    ref='gridRef'
                    :meta='gridMeta'
                    :args='gridArgs'
                    :showFilterPanel="false"
                    :to-remove-toolbar-items-names='removeGridToolbarBtns'
                ></ai-grid-ro>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ds-npot-par-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import tepService from '@/service/tep-service';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';
import AiNumberBox from '@/components/ai-number-box.vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const treeRef = ref(null);
const dataTree = ref(null);
const gridRef = ref(null);
const gridArgs = ref(null);
const selectedNsiKod = ref(null);
const defaultSaveArgs = ref({kod_norm: -1, depId: +getCookie('dep')});
const nameTree = ref(null);
const ttTree = ref(null);
const kpcTree = ref(null);
const kprTree = ref(null);
const ktwTree = ref(null);
const lookupNpotPeriodCreateList = ref(null);
const lookupNpotTipPrList = ref(null);
const lookupNpotTimeWorkList = ref(null);
const isChildTree = ref(true);

onMounted(async() => {
    await treeRef.value?.setDataSource();
    await onStartSelectTree();
});

const onStartSelectTree = async(keySelect = null) => {
    await getLookupsData();
    let keySelectTreeFocus = keySelect;
    if(!keySelectTreeFocus) {
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        keySelectTreeFocus = dataTree.value?.length ? dataTree.value[0].kod_norm : null;
    }
    selectedNsiKod.value = keySelectTreeFocus;
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);
    defaultSaveArgs.value.kod_norm = keySelectTreeFocus;
    isChildTree.value = dataTree.value?.some(i=> i.kod_r === selectedNsiKod.value);
    if(!isChildTree.value) {
        await getGridArgs(keySelectTreeFocus);
    }
    await getNameFields();
};

const getGridArgs = async (key) => {
    defaultSaveArgs.value.kod_norm = key;
    const defaultGridArgs = {
        select_args: { ...defaultSaveArgs.value },
    };
    gridArgs.value = { ...defaultGridArgs };
    await  setTimeout(async () =>{
        await gridRef.value?.setDataSource();
        const dataGrid = await gridRef.value?.getGridDataSource();
        const keySelectGridFocus = dataGrid?.length ? dataGrid[0].kod_norm : null;
        await gridRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    }, 100);
};

const getLookupsData = async () => {
    lookupNpotPeriodCreateList.value = await  tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-npot-period-create/select/get', {});
    lookupNpotTipPrList.value = await tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-npot-tip-pr/select/get', {});
    lookupNpotTimeWorkList.value = await tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-npot-time-work/select/get', {});
};

const getNameFields = async () => {
    nameTree.value = await treeValue('name');
    ttTree.value = await treeValue('tt');
    kpcTree.value = await treeValue('kod_period_create');
    kprTree.value = await treeValue('kod_pr');
    ktwTree.value = await treeValue('kod_time_work');
};

const treeValue =  (field) => {
    const rowData = dataTree.value?.find(el => el.kod_norm === selectedNsiKod.value);
    return rowData ? rowData[field] : null
};

const onTreeCellClick = async (event, newEl = false) => {
    selectedNsiKod.value = event.key;
    await getNameFields();

    isChildTree.value = dataTree.value?.some(i=> i.kod_r === selectedNsiKod.value);
    if(!isChildTree.value) {
        if(selectedNsiKod.value !== defaultSaveArgs.value.kod_norm) {
            await getGridArgs(selectedNsiKod.value);
        }
    }
};

const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton','copy', 'moveTo',
    'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'addSibling', 'addChild', 'delete', 'save', 'settings',
    'cut', 'put' ];
const removeGridToolbarBtns = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy'];

const treeMeta = {
    "keyExpr": "kod_norm",
    "columns": [
        {
            "name": "kod_norm",
            "caption": "kod_norm",
            "dataField": "kod_norm",
            "allowEditing": false,
            "width": 250,
            "index": 1,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Наименование",
            "dataField": "name",
            "allowEditing": false,
            "width": '100%',
            "index": 2,
            "visible": true
        },
        {
            "name": "kod_period_create",
            "caption": "kod_period_create",
            "dataField": "kod_period_create",
            "allowEditing": false,
            "width": 250,
            "index": 3,
            "visible": false
        },
        {
            "name": "kod_r",
            "caption": "kod_r",
            "dataField": "kod_r",
            "allowEditing": false,
            "width": 250,
            "index": 4,
            "visible": false
        },
        {
            "name": "kod_pr",
            "caption": "kod_pr",
            "dataField": "kod_pr",
            "allowEditing": false,
            "width": 250,
            "index": 5,
            "visible": false
        },
        {
            "name": "kod_time_work",
            "caption": "kod_time_work",
            "dataField": "kod_time_work",
            "allowEditing": false,
            "width": 250,
            "index": 6,
            "visible": false
        },
        {
            "name": "tt",
            "caption": "tt",
            "dataField": "tt",
            "allowEditing": false,
            "width": 250,
            "index": 7,
            "visible": false
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/ds-npot-par-tree/select/get",
        "save": "tep-nsi./tep-nsi/ds-npot-par-tree/save/set"
    },
    "viewId": "view-ds-npot-par-tree",
    "parentIdExpr": "kod_r",
    'findTool': 'filter',
    'selectButtonMode': 'single',
    'selectionMode': 'single',
    'maxWidth': 'w-full',
    'wordWrapEnabled': true,
    'allowColumnResizing': false,
};

const selectMeta = {
    'kod_period_create': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-npot-period-create/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-npot-period-create"
    },
    'kod_pr': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-npot-tip-pr/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-npot-tip-pr"
    },
    'kod_time_work': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-npot-time-work/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-npot-time-work"
    }
};
const gridMeta =  {
    'keyExpr': 'kod_npot_q3_par',
    'columns': [
        {
            'name': 'kod_npot_q3_par',
            'caption': 'kod_npot_q3_par',
            'dataField': 'kod_npot_q3_par',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kod_norm',
            'caption': 'kod_norm',
            'dataField': 'kod_norm',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'du',
            'caption': 'Du труб(мм)',
            'dataField': 'du',
            'allowEditing': false,
            'width': '50%',
            'index': 4,
            'visible': true,
            'dataType': 'number',
        },
        {
            'name': 'qq',
            'caption': 'Нормы потерь (Ккал/(м.куб./час))',
            'dataField': 'qq',
            'allowEditing': false,
            'dataType': 'number',
            'width': '50%',
            'index': 5,
            'visible': true,
        },

    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/ds-npot-par-grid/select/get',
        'save': 'tep-nsi./tep-nsi/ds-npot-par-grid/save/set',
    },
    'viewId': 'view-ds-npot-par-grid',
};
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 500px;
}
.tep-grid-name {
    width: 100%;
    text-align: center;
    padding: 10px 0;
}
.tep-header-item {
    align-items: center;
    gap: 4px;
}

.tep-header-label {
    width: 155px;
    text-align: right;
}
.tep-header_block {
    margin: 0 0 20px;
    padding: 0 0 20px;
    border-bottom: 1px solid  rgba(191, 191, 191, .7);;
}
.tep-header-input {
    width: 300px;
}
:root .tep-header-input :deep(.dx-field-value) {
    width: 100%;
}

.tep-header-input :deep(.dx-state-disabled.dx-widget){
    opacity: 1;
}
.tep-grid__container {
    height: calc(100% - 300px);
}
</style>

